<template>
  <div :class="['cars', { 'cars_fix-layout': fixLayout }]">
    <Car
      v-for="(car, index) in cars"
      :key="`car-${index}`"
      :car="car"
      tabindex="0"
      class="cars__car"
      @select="$emit('select', $event)"
    />
  </div>
</template>

<script>
  import Car from '@/components/Cars/Car'

  export default {
    name: 'Cars',
    components: {
      Car
    },
    props: {
      cars: {
        type: Array,
        required: true
      }
    },
    computed: {
      fixLayout () {
        // when there are 2 items in last row –
        // add extra (third) item to move second to center column
        return this.cars.length % 3 === 2
      }
    }
  }
</script>

<style lang="scss">
  .cars {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    &_fix-layout::after {
      @include notMobile {
        display: block;
        width: 205px;
        content: "";
      }
    }

    @include mobile {
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }

    &__car {
      width: 205px;
      margin-bottom: 40px;

      @include mobile {
        width: 100%;
        margin-bottom: 45px;
      }
    }
  }
</style>
